import { Card, CardPrice } from "@models/card.model";

export class Binder{
	ident: string;
	name: string;
	refProvider?: string=null;
	brand: string="Legend-Binder";
	img: string;
	nbPage: number;
	width: number;
	height: number;
	state: string;
}

export class UserBinder{
	ident?: string=null;
	binder?: string=null;
	util?: string=null;
	openedAt?: string=null;
	amount: number=0;
	isFavorite?: Date=null;
}

export class Page{
	ident: string;
	binder: string;
	index: number=0;
	img?: string=null;
	scan: string;
	amount: number=0;
	isFavorite?: Date=null;
	state: string;
}

export class CardBinder{
	ident: string=null;
	binder: string=null;
	page: string=null;
	scan?: string=null;
	img?: string=null;
	card?: string=null;
	variante?: string=null;
	condition: string;
	lang: string;
	amount: number=null;
	isFavorite?: Date=null;
	price: CardPrice;
	prices: CardPrice[];
	state: string;
}

export class CardCondition{
	ref: string;
	name: string;
}

export class Scan{
	ident: string;
	user: string;
	binder: string;
	img: string;
	type: 'page' | 'card';
	dateScan: Date;
	lastUpdate: Date;
	state: ScanState;
}

export type ScanState='waiting' | 'queued' | 'finished' | 'cancel';

export class BinderDetails{
	uBinder: UserBinder;
	pages: Page[]=[];
	cards: CardBinder[]=[];
	scans: Scan[]=[];
}

export class TopK{
	score: number;
	rank: number;
	card: Card;
	isBest: boolean;
	isBestFinal: boolean;
}

export class Share{
	ident: string;
	user: string;
	type: string;
	element: string;
	start: Date;
	end?: Date=null;
}
